﻿/**
 * Owl Carousel v2 Integration
 * 
 * This file references the external Owl Carousel v2 library located at:
 * /Users/anthonyclarke/Projects/attrax/src/Copernicus.Web/wwwroot/owlCarouselV2/owlCarouselV2.js
 * 
 * Both jQuery and owlCarouselV2.js should be loaded via script tags in the HTML before this module.
 * Example:
 * <script src="path/to/jquery.js"></script>
 * <script src="/owlCarouselV2/owlCarouselV2.js"></script>
 * 
 * This approach allows the CMS to control the loading of both jQuery and Owl Carousel
 * and ensures compatibility with the existing CMS infrastructure.
 */

// Type declarations for global jQuery and Owl Carousel v2
declare global {
    interface Window {
        jQuery: JQueryStatic;
        $: JQueryStatic;
    }
    interface JQuery {
        owlCarousel(options?: any): JQuery;
    }
}

// Use global jQuery provided by CMS
const getJQuery = (): JQueryStatic => {
    if (typeof window !== 'undefined' && window.jQuery) {
        return window.jQuery;
    }
    if (typeof window !== 'undefined' && window.$) {
        return window.$;
    }
    throw new Error('jQuery is not available in the global scope. Please ensure jQuery is loaded before this script.');
};

export class Carousels {
    //Function to create a owl carousel on elements;
    private static createCarousel(el, opt): void {
        if (el && el.length) {
            el.addClass("owl-carousel").owlCarousel(opt);
        }
    }

    //private static destroyCarousel(el) {

    //    if (el & el.length) {
    //        el.trigger('destroy.owl.carousel');
    //        el.removeClass("owl-carousel");
    //    }
    //}

    private static CtaBannerOne: JQuery;
    private static CtaBannerTwo: JQuery;
    private static quotesCarousel: JQuery;
    private static Brands: JQuery;
    private static InstagramBanner: JQuery;
    private static awardsCarousel: JQuery;
    private static jobDetailsCarousel: JQuery;
    private static jobsCarousel: JQuery;
    private static postCarousel: JQuery;
    private static TeamsCarousel: JQuery;
    private static JobdetailsScrollingCarousel: JQuery;

    public static createCarousels($jq: JQueryStatic): void {
        this.CtaBannerOne = $jq(".mb-cta-banner-one");
        const CtaBannerOneSettings = {
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 8500,
            autoplaySpeed: 2000,
            autoWidth: false,
            navText: ["", ""],
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        };
        this.createCarousel(this.CtaBannerOne, CtaBannerOneSettings);

        this.CtaBannerTwo = $jq(".mb-cta-banner-two");
        const CtaBannerTwoSettings = {
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            responsiveClass: true,
            autoWidth: false,
            navText: ["", ""],
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        };
        this.createCarousel(this.CtaBannerTwo, CtaBannerTwoSettings);

        this.jobsCarousel = $jq(".jobs-carousel .attrax-list-widget__list");
        const jobsCarouselSettings = {
            items: 1,
            loop: true,
            nav: true,
            responsiveClass: true,
            navText: ["", ""],
            onInitialized: Carousels.refreshCarousels($jq),
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                },
                1366: {
                    items: 3,
                },
                1700: {
                    items: 4,
                },
            },
        };
        this.createCarousel(this.jobsCarousel, jobsCarouselSettings);

        this.InstagramBanner = $jq(".mb-instagram-banner");
        const InstagramSettings = {
            items: 1,
            animateOut: "fadeOut",
            animateIn: "fadeIn",
            autoplay: true,
            loop: true,
            responsiveClass: true,
            autoWidth: false,
            navText: ["", ""],
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        };
        this.createCarousel(this.InstagramBanner, InstagramSettings);

        this.quotesCarousel = $jq(".mb-quotes-banner");
        const quotesCarouselSettings = {
            items: 1,
            loop: true,
            nav: false,
            navText: [
                "<i class='fal fa-long-arrow-left'></i>",
                "<i class='fal fa-long-arrow-right'></i>",
            ],
            dots: true,
            responsiveClass: true,
            autoWidth: false,
            margin: 80,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
                991: {
                    center: true,
                    margin: 60,
                    items: 3,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
            },
        };
        this.createCarousel(this.quotesCarousel, quotesCarouselSettings);

        this.awardsCarousel = $jq(".mb-awards-banner");
        const awardsCarouselSettings = {
            items: 1,
            loop: true,
            nav: true,
            navText: [
                "<i class='fal fa-long-arrow-left'></i>",
                "<i class='fal fa-long-arrow-right'></i>",
            ],
            dots: true,
            responsiveClass: true,
            autoWidth: false,
            margin: 30,
            responsive: {
                0: {
                    items: 2,
                },
                768: {
                    items: 3,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
                991: {
                    center: true,
                    margin: 40,
                    items: 3,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
            },
        };
        this.createCarousel(this.awardsCarousel, awardsCarouselSettings);

        this.jobDetailsCarousel = $jq(".mb-bottom-banner");
        const jobDetailsCarouselSettings = {
            items: 1,
            loop: true,
            nav: false,
            // navText : ["<i class='fal fa-long-arrow-left'></i>","<i class='fal fa-long-arrow-right'></i>"],
            dots: true,
            responsiveClass: false,
            autoWidth: false,
        };
        this.createCarousel(
            this.jobDetailsCarousel,
            jobDetailsCarouselSettings
        );

        this.postCarousel = $jq(".post-carousel .attrax-list-widget__list");
        const postCarouselSettings = {
            items: 1,
            loop: true,
            nav: true,
            margin: 20,
            responsiveClass: true,
            center: true,
            navText: ["", ""],
            onInitialized: () => {
                const nav = $jq(".post-carousel .owl-nav");
                const tabs = $jq(".post-carousel .attrax-list-widget__tabs");

                tabs.append(nav);
            },

            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2.5,
                    center: false,
                },
                1366: {
                    items: 3.5,
                    center: true,
                },
            },
        };
        this.createCarousel(this.postCarousel, postCarouselSettings);

        $jq(window).on("load", function () {
            const currentWidth = $jq(this).width() ?? 0;
            if (currentWidth <= 991) {
                Carousels.Brands = $jq(
                    ".brands__brand-cards-container, .loving__brand-cards-container"
                );
                const BrandsSettings = {
                    items: 1,
                    loop: true,
                    nav: true,
                    dots: true,
                    responsiveClass: true,
                    autoWidth: false,
                    navText: ["", ""],
                    responsive: {
                        0: {
                            items: 1,
                        },
                        768: {
                            items: 2,
                        },
                    },
                };
                Carousels.createCarousel(Carousels.Brands, BrandsSettings);
            }
        });


        this.TeamsCarousel = $jq(".teams-banner");
        const teamsCarouselSettings = {
            items: 1,
            loop: true,
            nav: false,
            navText: [
                "<i class='fal fa-long-arrow-left'></i>",
                "<i class='fal fa-long-arrow-right'></i>",
            ],
            dots: true,
            responsiveClass: true,
            autoWidth: false,
            margin: 80,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
                991: {
                    center: true,
                    margin: 60,
                    items: 3,
                    nav: true,
                    navText: [
                        "<i class='fal fa-long-arrow-left'></i>",
                        "<i class='fal fa-long-arrow-right'></i>",
                    ],
                },
            },
        };
        this.createCarousel(
            this.TeamsCarousel,
            teamsCarouselSettings
        );

        this.JobdetailsScrollingCarousel = $jq(".job-details-scrolling-banner");
        const JobdetailsScrollingCarouselSettings = {
            items: 1,
            loop: true,
            nav: true,
            navText: [
                "<i class='fal fa-long-arrow-left'></i>",
                "<i class='fal fa-long-arrow-right'></i>",
            ],
            center: true,
            dots: false,
            responsiveClass: true,
            autoplay:true,
            autoplayTimeout:5000,
            autoWIdth:true,
            onInitialized: Carousels.refreshCarousels($jq),
            autoplayHoverPause:true
        };
        this.createCarousel(
            this.JobdetailsScrollingCarousel,
            JobdetailsScrollingCarouselSettings
        );
    }

    public static refreshCarousels($jq: JQueryStatic): void {
        Carousels.jobsCarousel.trigger("refresh.owl.carousel", [500]);
    }
}
